module.exports = __webpack_public_path__ + "static/media/TMT 1a3.bfdd55fa.jpg";